import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import { WebArmIsuResponce } from '@/models/consultationWebModel';
import ConsultationWebRepository from '@/repositories/consultationWebRepository';
import cognitoRepository from '@/repositories/common/cognitoRepository';
import utils from '@/commonProject/helpers/utils';

export const useConsultationWebStore = defineStore({
    id: 'consultationWeb',
    state: () => ({
        // Web相談一覧情報
        consultationList: [],
        // Webメッセージ一覧情報
        messageList: {},
        // Web相談詳細情報レスポンス
        webdtlResponce: {},
        // Web相談登録入力(ARM型)セレクトボックス内容
        armRegistrationIssue: [],
        // Web相談登録入力(TMS型)セレクトボックス内容
        tmsRegistrationIssue: [],
        // Web相談登録入力(TMS型)アンケート内容情報レスポンス
        webCngTmsFormAttrResponce: [],
        // Web相談登録入力(TMS型)アンケート回答情報レスポンス
        webCngTmsFormDataResponce: [],
        // お知らせ送信履歴PK
        noticeHistPk: '',
    }),
    actions: {
        reset() {
            this.consultationList = [];
            this.messageList = {};
            this.webdtlResponce = {};
            this.armRegistrationIssue = [];
            this.tmsRegistrationIssue = [];
            this.webCngTmsFormAttrResponce = [];
            this.webCngTmsFormDataResponce = [];
        },
        /**
         * Web相談登録入力Formのデータクリア
         */
        async clearRegistrationFormData() {
            this.noticeHistPk = '';
            this.webdtlResponce = {};
        },
        /**
         * Web相談一覧取得処理
         */
        async postWebLstAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const consultationWebRepository = new ConsultationWebRepository();

            try {
                const response = await consultationWebRepository.postWebLstActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.consultationList = response.data.List;
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談の詳細情報取得処理
         */
        async getRegistrationInformation(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            this.tmsRegistrationIssue1 = [];
            this.tmsRegistrationIssue2 = [];
            this.tmsRegistrationIssue3 = [];
            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.getWebDtlActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.webCngTmsFormDataResponce = response.data.WebCngTmsFormData;
                this.webCngTmsFormAttrResponce = response.data.WebCngTmsFormAttr;
                this.webdtlResponce = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談メッセージ一覧取得処理
         */
        async getMessageList(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postMsgLstActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.messageList = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談メッセージ既読登録処理
         */
        async registerAlreadyRead(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postWebMsgRedActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談メッセージ登録処理
         */
        async registerMessage(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postwebMsgDtlActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談イシュー一覧取得処理
         */
        async getArmIssue(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            // イシューの初期選択を初期化する。
            this.armRegistrationIssue = [];

            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postWebArmIsuActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                // APIから配列がnullで来るので暫定対応（このまま放置でも大丈夫）
                if (!utils.isNullEmpty(response.data.List)) {
                    this.armRegistrationIssue = response.data.List.map((item) => WebArmIsuResponce.formApiResponse(item));
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談TMS相談分類取得セレクトボックス情報取得処理
         */
        async getIssue(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            this.tmsRegistrationIssue = [];
            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postWebTmsCatActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.tmsRegistrationIssue = response.data.List;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * Web相談登録処理
         */
        async registerConsultationWeb(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const consultationWebRepository = new ConsultationWebRepository();
            try {
                const response = await consultationWebRepository.postConsultationWebActionApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'put', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存
        storage: sessionStorage,
    },
});
